import { NgClass } from "@angular/common";
import { Component } from "@angular/core";
import { EnumPipe } from "../../../shared/pipes/enum.pipe";
import { NewUiKpiCardComponent } from "./new-ui-kpi-card.component";

@Component({
  selector: "app-kpi-card",
  templateUrl: "./kpi-card.component.html",
  styleUrl: "./kpi-card.component.scss",
  imports: [NgClass, EnumPipe],
})
export class KpiCardComponent extends NewUiKpiCardComponent {}
